<div class="p-6 bg-light-surface dark:bg-dark-surface flex flex-col max-h-[90vh] overflow-hidden">
  <!-- Header -->
  <div class="flex items-center gap-2 pb-4">
    <lucide-angular [img]="Settings2" class="w-5 h-5 !pt-0 text-light-primary dark:text-dark-primary"></lucide-angular>
    <h1 class="!mb-0 !pb-0">Editar Selector</h1>
    @if (itemsFormArray.length > 0) {
      <div class="hidden md:flex text-light-text-tertiary dark:text-dark-text-tertiary">
        <lucide-angular [img]="ChevronRight" class="w-5 h-5"></lucide-angular>
      </div>
    }
    @if (itemsFormArray.length > 0) {
      <h2 class=" !font-normal !pt-0 !mb-0 !pb-0 text-light-primary dark:text-dark-primary">
        {{ selectedTypeName || '' }}
      </h2>
    }
  </div>

  <!-- Content with scroll -->
  <mat-dialog-content class="flex-1 overflow-y-auto h-full !px-0 !py-0 dark:[color-scheme:dark]">
    @if (picklistForm) {
      <form [formGroup]="picklistForm" class="space-y-0">
        <!-- Selector de tipo de picklist -->
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Escoja un selector...</mat-label>
          <mat-select formControlName="selectedType" (selectionChange)="onTypeChange($event.value)" [disabled]="saving">
            @for (type of data.picklists.types; track type) {
              <mat-option
                [value]="type.picklistTypeId"
                class="text-light-text dark:text-dark-text">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
          @if (picklistForm.get('selectedType')?.hasError('required')) {
            <mat-error>
              Debe seleccionar un tipo de selector
            </mat-error>
          }
        </mat-form-field>
        <!-- Separador -->
        @if (itemsFormArray.length > 0) {
          <div class="border-t border-light-border dark:border-dark-border"></div>
        }
        @if (itemsFormArray.length > 0) {
          <div class="flex-1 max-w-md py-2">
            <div class="relative">
              <input
                [value]="searchQuery"
                (input)="onSearchChange($any($event.target).value)"
                placeholder="Buscar item..."
                type="text"
                class="search-input !py-1.5 pl-12"
                />
              <lucide-angular
                class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary"
                [img]="Search">
              </lucide-angular>
            </div>
          </div>
        }
        <!-- Lista de Items -->
        <div formArrayName="items" class="space-y-0 max-h-96 overflow-y-auto pr-2">
          @if (loading && selectedTypeId) {
            <div class="flex justify-center py-6">
              <mat-spinner diameter="32"></mat-spinner>
            </div>
          }
          @for (itemData of filteredItems; track itemData) {
            <div>
              <form [formGroup]="$any(itemData.control)" class="flex gap-2 items-start">
                <!-- Form fields container -->
                <div class="w-4/5 flex gap-2 items-start">
                  <!-- Nombre del item existente (solo lectura) -->
                  @if (isExistingItem(itemData.index)) {
                    <div class="flex-1 max-w-[300px] py-3 px-4 rounded-lg border border-light-border dark:border-dark-border">
                      <span class="text-light-text dark:text-dark-text">
                        {{ $any(itemData.control).get('name')?.value }}
                      </span>
                      @if (isIdentifierType) {
                        <div class="mt-1">
                          <span class="text-xs text-light-text-tertiary dark:text-dark-text-tertiary">Prefijo: {{ $any(itemData.control).get('value')?.value || '-' }}</span>
                        </div>
                      }
                    </div>
                  }
                  <!-- Nombre del item nuevo (editable) -->
                  @if (!isExistingItem(itemData.index)) {
                    <mat-form-field appearance="fill" class="flex-1 max-w-[300px]">
                      <mat-label>Nombre</mat-label>
                      <input matInput formControlName="name" placeholder="Ej: Opción 1"
                        class="text-light-text dark:text-dark-text">
                      @if ($any(itemData.control).get('name')?.hasError('required')) {
                        <mat-error>
                          El nombre es requerido
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (isIdentifierType) {
                      <mat-form-field appearance="fill" class="flex-none w-32">
                        <mat-label>Prefijo</mat-label>
                        <input matInput formControlName="value" placeholder="Ej: ABC"
                          class="text-light-text dark:text-dark-text">
                        @if ($any(itemData.control).get('value')?.hasError('required')) {
                          <mat-error>Requerido</mat-error>
                        }
                      </mat-form-field>
                    }
                  }
                  <!-- Estado -->
                  <mat-form-field appearance="fill" class="flex-none w-32">
                    <mat-label>Estado</mat-label>
                    <mat-select formControlName="isActive">
                      <mat-option [value]="true">Activo</mat-option>
                      <mat-option [value]="false">Inactivo</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Icono de basura (solo para items nuevos) -->
                <div class="flex items-center pb-4">
                  @if (!isExistingItem(itemData.index)) {
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="removeItem(itemData.index)"
                      [disabled]="saving">
                      <lucide-icon [name]="Trash2"></lucide-icon>
                    </button>
                  }
                  <!-- Placeholder para items existentes para mantener alineación -->
                  @if (isExistingItem(itemData.index)) {
                    <div class="w-10 h-10"></div>
                  }
                </div>
              </form>
            </div>
          }
          <!-- Empty State cuando no hay resultados de búsqueda -->
          @if (itemsFormArray.length > 0 && filteredItems.length === 0) {
            <div class="text-center py-8">
              <p class="normal">
                No se encontraron items con "{{ searchQuery }}"
              </p>
            </div>
          }
        </div>
        <!-- Botón Agregar Item -->
        @if (itemsFormArray.length > 0) {
          <div class="pb-4 pt-2">
            <button
              mat-button
              (click)="addNewItem()"
              [disabled]="!canAddItems || saving"
              class="!bg-light-primary/10 dark:!bg-dark-primary/20 !text-light-primary dark:!text-dark-primary !rounded-xl !px-6 !py-5">
              <div>
                <span>Agregar item</span>
              </div>
            </button>
          </div>
        }
      </form>
    }
  </mat-dialog-content>

  <div class="border-t border-light-border dark:border-dark-border mt-5 mb-5"></div>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="flex-shrink-0 bg-light-surface dark:bg-dark-surface gap-3 !pb-0">
    <button
      (click)="onCancel()"
      [disabled]="saving"
      class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
      Cancelar
    </button>
    <button
      color="primary"
      (click)="onSave()"
      [disabled]="!hasChanges || saving"
      class="flex gap-2 items-center font-medium !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl h-10 !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed duration-200">
      <div class="flex items-center justify-center gap-2">
        @if (!saving) {
          <span>Guardar cambios</span>
        }
        @if (saving) {
          <span>Guardando...</span>
        }
        @if (saving) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </div>
    </button>
  </mat-dialog-actions>
</div>